var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsContentWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H24.001V23.9999H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4009 16.048C18.4009 16.396 18.2569 16.7396 18.0093 16.988L16.9689 18.016C16.7209 18.264 16.3849 18.4 16.0413 18.4H15.9889C10.4009 18.1596 5.84086 13.6 5.60086 8.016C5.58486 7.652 5.72486 7.292 5.98486 7.032L7.01286 5.992C7.26086 5.744 7.60486 5.6 7.95686 5.6H8.34086C8.88886 5.6 9.38886 5.944 9.58086 6.46L10.4929 8.88C10.6689 9.352 10.5609 9.892 10.2129 10.26L9.83686 10.656C9.66486 10.836 9.64486 11.112 9.78486 11.316C10.2489 11.988 11.2409 13.256 12.6889 14.232C12.8889 14.364 13.1609 14.34 13.3369 14.172L13.7449 13.788C14.1093 13.44 14.6489 13.332 15.1209 13.508L17.5413 14.42C18.0569 14.616 18.4009 15.112 18.4009 15.6596V16.048ZM12.0009 2C6.48486 2 2.00086 6.488 2.00086 12C2.00086 13.836 2.50086 15.6236 3.45286 17.184L2.02086 21.4756C1.97286 21.62 2.00886 21.7756 2.11686 21.884C2.19286 21.9596 2.29686 22 2.40086 22C2.44486 22 2.48486 21.996 2.52886 21.98L6.81686 20.552C8.38086 21.5 10.1689 22 12.0009 22C17.5169 22 22.0009 17.516 22.0009 12C22.0009 6.488 17.5169 2 12.0009 2Z",
    fill: "red"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsContentWhatsapp);
export default __webpack_public_path__ + "static/media/icons-content-whatsapp.8b3ca8d1d5c64d98e57927fc64ea4298.svg";
export { ForwardRef as ReactComponent };